module.exports = __webpack_public_path__ + "fonts/Gilroy-MediumItalic.f8ac8bc5.woff";